export const dateToMysqlFormat = (date: Date) => date.toJSON().slice(0, 19).replace('T', ' ');

export const nowToMysqlFormat = () => dateToMysqlFormat(new Date());
